import { useLayoutEffect } from 'react';
// Match the completed article lifecycle: the route owns managed metadata while
// mounted; restore the entry document's unmanaged nodes on departure.
export default function useScopedDocument(enabled = true, ready = true) {
  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const nodes = [...document.head.querySelectorAll('meta[name="description"]:not([data-rh]),meta[name="robots"]:not([data-rh]),meta[name="googlebot"]:not([data-rh]),link[rel="canonical"]:not([data-rh])')];
    const saved = nodes.map(node => ({ node, parent: node.parentNode, next: node.nextSibling }));
    nodes.forEach(node => node.remove());
    return () => saved.forEach(({ node, parent, next }) => parent.insertBefore(node, next?.parentNode === parent ? next : null));
  }, [enabled]);
  useLayoutEffect(() => {
    if (!enabled || !ready) return undefined;
    const nodes = [...document.querySelectorAll('body > [data-seo-content]')];
    const saved = nodes.map(node => ({ node, parent: node.parentNode, next: node.nextSibling }));
    nodes.forEach(node => node.remove());
    return () => saved.forEach(({ node, parent, next }) => parent.insertBefore(node, next?.parentNode === parent ? next : null));
  }, [enabled, ready]);
}
